<script setup lang="ts">
import { APPLY_STATUS } from '@/config/enum'
import router from '@/router'

const { t } = useI18n()
const userStore = useUserStore()
const { info, isLogin, isCreator } = storeToRefs(userStore)

const showModal = ref(false)
const domainName = ref('')
const loading = ref(false)

useLockAppScrollWhenVisible(showModal)

const link = computed(() => {
  return domainName.value ? `https://dfans.xyz/${domainName.value}` : ''
})

const getUserInfo = async () => {
  try {
    loading.value = true
    const loginRes = await baseService.refreshToken()
    Cookie.set('BMS-Authorization', loginRes.token)
    Cookie.set('Authorization', loginRes.token)
    Local.set('BMS-Authorization', loginRes.token)
    Local.set('Authorization', loginRes.token)
    const userRes = await baseService.profileInfo({
      addressOrDomain: info.value?.address,
    })
    loginRes.info = {
      ...loginRes.info,
      ...userRes,
    }
    userStore.INIT({
      ...loginRes,
      address: userRes.address,
    })
  } catch (error) {
    console.error(error)
  } finally {
    loading.value = false
  }
}

// 查询申请状态
const queryApplyCreateStatus = async () => {
  try {
    const res = await baseService.queryApplyCreate(info.value?.address)
    const { status, domain, firstName } = res || {}
    domainName.value = domain || firstName
    showModal.value = +status === APPLY_STATUS.APPROVED
    if (!isCreator.value && showModal.value) {
      getUserInfo()
    }
    Local.set('applyStatus', status)
  } catch (error) {
    console.error(error)
    showModal.value = false
  }
}

const show = () => {
  const applyStatus = Local.get('applyStatus')
  if (!isLogin.value) return
  if ((applyStatus !== null && +applyStatus === APPLY_STATUS.APPROVED) || isCreator.value) return
  // 查询申请状态
  queryApplyCreateStatus()
}
const openModal = () => {
  showModal.value = true
}
const jumpPage = () => {
  setTimeout(() => {
    showModal.value = false
    router.push({
      name: 'EditProfile',
    })
  }, 200)
}

defineExpose({
  show,
  openModal,
})
</script>

<template>
  <n-modal v-model:show="showModal" :mask-closable="false" transform-origin="center">
    <div
      class="modal-content relative sm:w-105 sm:min-h-60 sm:p-6 w-85.75 min-h-52 p-4 w-11/12 sm:w-105"
    >
      <div class="sm:text-5.5 sm:leading-6.5 text-4.5 leading-6 text-center typeface-robotoMedium">
        {{ t('Global.ApplicationApproved') }}
      </div>
      <div class="mt-6 text-center text-4 leading-6">
        <div class="text-4 leading-6">{{ t('Global.YourDFansPageIs') }}:</div>
        <div class="flex justify-center items-center sm:mt-3 mt-1 font-bg">
          {{ link }}
          <CopyIcon :info="link" />
        </div>
        <DfansButton
          :text="t('Btn.CreateSubscriptionTiers')"
          type="default"
          :loading="loading"
          class="sm:h-11 !sm:text-4 !sm:leading-6 mt-6 w-full h-10 !text-3.5 !leading-5 rounded-1.5"
          @click="jumpPage"
        />
      </div>
    </div>
  </n-modal>
</template>
